import gql from 'graphql-tag'

const categoryListFragment = gql`
  fragment CategoryListFragment on Article {
    categoryList {
      edges {
        node {
          id
          name
        }
      }
    }
  }`

const articleLinkAssetListFragment = gql`
  fragment ArticleLinkAssetListFragment on Article {
    articleLinkAssetList {
      edges {
        node {
          id,
          asset {
            title
            caption
            source
            author
            path
            urlWithProtocol
          },
          position
        }
      }
    }
  }`

const authorListFragment = gql`
  fragment AuthorListFragment on Article {
    authorList {
      edges {
        node {
          id
          fullname,
          imageAsset {
            path
            urlWithProtocol
          }
        }
      }
    }
}`

const articleBaseFragment = gql`
  fragment ArticleBaseFragment on Article {
    id
    path
    authorsString
    title
    perex
    magazine {
      name
    }
    previewAsset {
      path
      urlWithProtocol
      author
      source
    }
    published
  }`

const articleDetailFragment = gql`
  fragment ArticleDetailFragment on Article {
    ...ArticleBaseFragment
    ...CategoryListFragment
    ...ArticleLinkAssetListFragment
    ...AuthorListFragment
    jsonBody
    keywords
    rating
  }
  ${articleBaseFragment}
  ${categoryListFragment}
  ${articleLinkAssetListFragment}
  ${authorListFragment}
`

const articleRedactionFragment = gql`
  fragment ArticleRedactionFragment on Article {
    ...ArticleBaseFragment
    originalContent
  }
  ${articleBaseFragment}
`

export const GET_ARTICLES_PREVIEW = gql`
  query articles(
    $first: Int,
    $last: Int,
    $before: String,
    $after: String,
    $magazine: String,
    $magazineList: [String],
    $categoryList: String,
    $categoryListList: [String],
    $aiTopicList: String,
    $aiTopicListList: [String],
    $aiAuthorList: String,
    $aiAuthorListList: [String],
    $path: String,
    $pathList: [String],
    $id: String,
    $idList: [String],
    $originId: String,
    $originIdList: [String],
    $labelList: String,
    $labelListList: [String],
    $authorList: String,
    $authorListList: [String],
    $published: [ArticleFilter_published],
    $unpublished: [ArticleFilter_unpublished],
    $title: String,
    $perex: String,
    $body: String,
    $isDeleted: Boolean,
    $isCompleted: Boolean,
    $isPreview: Boolean,
    $premium: Boolean,
    $hasAiValues: Boolean
  ) {
    articles(
      first: $first
      last: $last
      before: $before
      after: $after
      magazine: $magazine
      magazine_list: $magazineList
      categoryList: $categoryList
      categoryList_list: $categoryListList
      path: $path
      path_list: $pathList,
      id: $id,
      id_list: $idList,    
      originId: $originId
      originId_list: $originIdList
      labelList: $labelList
      labelList_list: $labelListList
      authorList: $authorList
      authorList_list: $authorListList
      published: $published
      unpublished: $unpublished
      title: $title
      perex: $perex
      body: $body
      isDeleted: $isDeleted
      isCompleted: $isCompleted
      isPreview: $isPreview
      premium: $premium
      aiTopicList: $aiTopicList
      aiTopicList_list: $aiTopicListList
      aiAuthorList: $aiAuthorList
      aiAuthorList_list: $aiAuthorListList
      hasAiValues: $hasAiValues
    ) {
      edges {
        node {
          ...ArticleBaseFragment
          ...CategoryListFragment

        }
      }
    }
  }
  ${articleBaseFragment}
  ${categoryListFragment}
 
`

export const GET_ARTICLES_WITH_AUTHOR = gql`
  query articles(
    $first: Int,
    $last: Int,
    $before: String,
    $after: String,
    $magazine: String,
    $magazineList: [String],
    $categoryList: String,
    $categoryListList: [String],
    $aiTopicList: String,
    $aiTopicListList: [String],
    $aiAuthorList: String,
    $aiAuthorListList: [String],
    $path: String,
    $pathList: [String],
    $id: String,
    $idList: [String],
    $originId: String,
    $originIdList: [String],
    $labelList: String,
    $labelListList: [String],
    $authorList: String,
    $authorListList: [String],
    $published: [ArticleFilter_published],
    $unpublished: [ArticleFilter_unpublished],
    $title: String,
    $perex: String,
    $body: String,
    $isDeleted: Boolean,
    $isCompleted: Boolean,
    $isPreview: Boolean,
    $premium: Boolean,
    $hasAiValues: Boolean
  ) {
    articles(
      first: $first
      last: $last
      before: $before
      after: $after
      magazine: $magazine
      magazine_list: $magazineList
      categoryList: $categoryList
      categoryList_list: $categoryListList
      path: $path
      path_list: $pathList,
      id: $id,
      id_list: $idList,
      originId: $originId
      originId_list: $originIdList
      labelList: $labelList
      labelList_list: $labelListList
      authorList: $authorList
      authorList_list: $authorListList
      published: $published
      unpublished: $unpublished
      title: $title
      perex: $perex
      body: $body
      isDeleted: $isDeleted
      isCompleted: $isCompleted
      isPreview: $isPreview
      premium: $premium
      aiTopicList: $aiTopicList
      aiTopicList_list: $aiTopicListList
      aiAuthorList: $aiAuthorList
      aiAuthorList_list: $aiAuthorListList
      hasAiValues: $hasAiValues
    ) {
      edges {
        node {
          ...ArticleBaseFragment
          ...AuthorListFragment
          ...CategoryListFragment
          ...ArticleLinkAssetListFragment
        }
      }
    }
  }
  ${articleBaseFragment}
  ${categoryListFragment}
  ${articleLinkAssetListFragment}
  ${authorListFragment}
`

export const GET_ARTICLES_DETAIL = gql`
  query articles(
    $first: Int,
    $last: Int,
    $before: String,
    $after: String,
    $magazine: String,
    $magazineList: [String],
    $categoryList: String,
    $categoryListList: [String],
    $aiTopicList: String,
    $aiTopicListList: [String],
    $aiAuthorList: String,
    $aiAuthorListList: [String],
    $path: String,
    $pathList: [String],
    $id: String,
    $idList: [String],
    $originId: String,
    $originIdList: [String],
    $labelList: String,
    $labelListList: [String],
    $authorList: String,
    $authorListList: [String],
    $published: [ArticleFilter_published],
    $unpublished: [ArticleFilter_unpublished],
    $title: String,
    $perex: String,
    $body: String,
    $isDeleted: Boolean,
    $isCompleted: Boolean,
    $isPreview: Boolean,
    $premium: Boolean,
    $hasAiValues: Boolean
  ) {
    articles(
      first: $first
      last: $last
      before: $before
      after: $after
      magazine: $magazine
      magazine_list: $magazineList
      categoryList: $categoryList
      categoryList_list: $categoryListList
      path: $path
      path_list: $pathList
      id: $id,
      id_list: $idList,
      originId: $originId
      originId_list: $originIdList
      labelList: $labelList
      labelList_list: $labelListList
      authorList: $authorList
      authorList_list: $authorListList
      published: $published
      unpublished: $unpublished
      title: $title
      perex: $perex
      body: $body
      isDeleted: $isDeleted
      isCompleted: $isCompleted
      isPreview: $isPreview
      premium: $premium
      aiTopicList: $aiTopicList
      aiTopicList_list: $aiTopicListList
      aiAuthorList: $aiAuthorList
      aiAuthorList_list: $aiAuthorListList
      hasAiValues: $hasAiValues
    ) {
      edges {
        node {
          ...ArticleDetailFragment
        }
      }
    }
  }
  ${articleDetailFragment}
`

export const GET_ARTICLES_REDACTION = gql`
  query articles(
    $first: Int,
    $last: Int,
    $before: String,
    $after: String,
    $magazine: String,
    $magazineList: [String],
    $categoryList: String,
    $categoryListList: [String],
    $aiTopicList: String,
    $aiTopicListList: [String],
    $aiAuthorList: String,
    $aiAuthorListList: [String],
    $path: String,
    $pathList: [String],
    $id: String,
    $idList: [String],
    $originId: String,
    $originIdList: [String],
    $labelList: String,
    $labelListList: [String],
    $authorList: String,
    $authorListList: [String],
    $published: [ArticleFilter_published],
    $unpublished: [ArticleFilter_unpublished],
    $title: String,
    $perex: String,
    $body: String,
    $isDeleted: Boolean,
    $isCompleted: Boolean,
    $isPreview: Boolean,
    $premium: Boolean,
    $hasAiValues: Boolean
  ) {
    articles(
      first: $first
      last: $last
      before: $before
      after: $after
      magazine: $magazine
      magazine_list: $magazineList
      categoryList: $categoryList
      categoryList_list: $categoryListList
      path: $path
      path_list: $pathList
      id: $id,
      id_list: $idList,
      originId: $originId
      originId_list: $originIdList
      labelList: $labelList
      labelList_list: $labelListList
      authorList: $authorList
      authorList_list: $authorListList
      published: $published
      unpublished: $unpublished
      title: $title
      perex: $perex
      body: $body
      isDeleted: $isDeleted
      isCompleted: $isCompleted
      isPreview: $isPreview
      premium: $premium
      aiTopicList: $aiTopicList
      aiTopicList_list: $aiTopicListList
      aiAuthorList: $aiAuthorList
      aiAuthorList_list: $aiAuthorListList
      hasAiValues: $hasAiValues
    ) {
      edges {
        node {
          ...ArticleRedactionFragment
        }
      }
    }
  }
  ${articleRedactionFragment}
`